import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import { Alert, Badge, Container, Image } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import { Chip } from '@mui/material';
import {
    Stack,
    Button,
    Typography,
    Box
} from '@mui/material';

const RegistSelect = () => {
    async function getRegistOAuth(type) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/regist/oauth/" + type).then((r) => r.json().then((json) => {
            return json
        }))
    }
    const { t, i18n } = useTranslation()
    const location = useLocation()
    const [info, setInfo] = useState("")
    const navigate = useNavigate()

    useEffect(() => {
        document.querySelector("title").textContent = t("regist.signupMethod") + " - アワートAI"

        if (location.search.indexOf("autherror=4") !== -1) {
            setInfo(<><p>World IDはOrbによる認証が完了していないため、連携できません。</p></>)
        } else if (location.search.indexOf("autherror=5") !== -1) {
            setInfo(<><p>この外部アカウントは既に他のアワートアカウントに関連付けられているため使用できません。</p></>)
        } else if (location.search.indexOf("autherror") !== -1) {
            setInfo("認証に失敗しました。")
        }
    }, [location.pathname, i18n.language])
    // ローディング状態の管理
    const [loading, setLoading] = useState(false);

    // 共通のボタンスタイル - すべてのボタンで統一されたデザインを提供
    const buttonSx = {
        width: '100%',
        height: 48,
        backgroundColor: 'white',
        border: '1px solid',
        borderColor: 'grey.300',
        color: 'text.primary',
        textTransform: 'none',
        fontSize: '16px',
        '&:hover': {
            backgroundColor: 'grey.50',
            borderColor: 'grey.400'
        },
        '&.Mui-disabled': {
            backgroundColor: 'grey.100',
            borderColor: 'grey.300',
            color: 'text.disabled'
        }
    };

    // ボタン内部のコンテンツレイアウト用スタイル
    const buttonContentSx = {
        width: '100%',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        px: 3
    };

    // アイコン配置用のスタイル
    const iconContainerSx = {
        position: 'absolute',
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 24,
        height: 24
    };

    // テキスト配置用のスタイル
    const buttonTextSx = {
        width: '100%',
        textAlign: 'center',
        fontWeight: 500
    };
    return (
        <div className="wrapper">
            <header className="App-header"></header>
            <Header />
            <Category />
            <Container className='text-center'>
                <h3>{t("regist.signup")}</h3>
                {info && (<Alert variant='danger'>{info}</Alert>)}
                <Stack spacing={2} sx={{ width: '100%', maxWidth: 'sm', mx: 'auto' }}>
                    {/* Google登録ボタン */}
                    <Button
                        variant="contained"
                        disabled={loading}
                        onClick={() => {
                            setLoading(true);
                            getRegistOAuth("google").then(r => {
                                if (r.result) {
                                    window.location.href = r.data.url;
                                } else {
                                    navigate("/regist-select?autherror=1");
                                    setLoading(false);
                                }
                            }).catch(() => {
                                setLoading(false);
                            });
                        }}
                        sx={buttonSx}
                    >
                        <Box sx={buttonContentSx}>
                            <Box sx={iconContainerSx}>
                                <Icon.Google />
                            </Box>
                            <Typography sx={buttonTextSx}>
                                {t("regist.signupWithGoogle")}
                            </Typography>
                        </Box>
                    </Button>

                    {/* X (Twitter)登録ボタン */}
                    <Button
                        variant="contained"
                        disabled={loading}
                        onClick={() => {
                            setLoading(true);
                            getRegistOAuth("x").then(r => {
                                if (r.result) {
                                    window.location.href = r.data.url;
                                } else {
                                    navigate("/regist-select?autherror=1");
                                    setLoading(false);
                                }
                            }).catch(() => {
                                setLoading(false);
                            });
                        }}
                        sx={buttonSx}
                    >
                        <Box sx={buttonContentSx}>
                            <Box sx={iconContainerSx}>
                                <Icon.TwitterX />
                            </Box>
                            <Typography sx={buttonTextSx}>
                                {t("regist.signupWithTwitterId")}
                            </Typography>
                        </Box>
                    </Button>

                    {/* LINE登録ボタン */}
                    <Button
                        variant="contained"
                        disabled={loading}
                        onClick={() => {
                            setLoading(true);
                            getRegistOAuth("line").then(r => {
                                if (r.result) {
                                    window.location.href = r.data.url;
                                } else {
                                    navigate("/regist-select?autherror=1");
                                    setLoading(false);
                                }
                            }).catch(() => {
                                setLoading(false);
                            });
                        }}
                        sx={buttonSx}
                    >
                        <Box sx={buttonContentSx}>
                            <Box sx={iconContainerSx}>
                                <Icon.Line />
                            </Box>
                            <Typography sx={buttonTextSx}>
                                {t("regist.signupWithLINE")}
                            </Typography>
                        </Box>
                    </Button>

                    {/* OurtAI登録ボタン */}
                    <Link
                        to="/regist"
                        style={{
                            textDecoration: 'none',
                            width: '100%'
                        }}
                    >
                        <Button
                            variant="contained"
                            sx={buttonSx}
                        >
                            <Box sx={buttonContentSx}>
                                <Typography sx={buttonTextSx}>
                                    {t("regist.signupWithOurtAI")}
                                </Typography>
                            </Box>
                        </Button>
                    </Link>

                    {/* World ID登録ボタン */}
                    <Button
                        variant="contained"
                        disabled={loading}
                        onClick={() => {
                            setLoading(true);
                            getRegistOAuth("worldId").then(r => {
                                if (r.result) {
                                    window.location.href = r.data.url;
                                } else {
                                    navigate("/regist-select?autherror=1");
                                    setLoading(false);
                                }
                            }).catch(() => {
                                setLoading(false);
                            });
                        }}
                        sx={buttonSx}
                    >
                        <Box sx={buttonContentSx}>
                            <Box sx={iconContainerSx}>
                                <img
                                    src="/img/logos/worldcoin-org-wld-logo.svg"
                                    alt="World ID"
                                    width={24}
                                    height={24}
                                />
                            </Box>
                            <Typography sx={buttonTextSx}>
                                World ID
                            </Typography>
                        </Box>
                    </Button>
                </Stack>
            </Container>
            <Footer />
        </div>
    )
}

export default RegistSelect;
